import React, { createContext, useState } from "react";

const DashboardContext = createContext();

/**
 * @param {React.ReactChild} chidren Children components inside the context
 * @returns {React.Provider} Dashboard Module context for redirection from other modules
 */
const DashboardProvider = ({ children }) => {
  const [trafficPlusEnabled, setTrafficPlusEnabled] = useState(0);
  const [isDIYAccount, setIsDIYAccount] = useState(false);
  const [selectedAcc, setSelectedAcc] = useState(null);
  const [selectedBrand, setSelectedBrand] = useState({ value: 0 });
  const [selectedSite, setSelectedSite] = useState(null);
  const [selectedDCValue, setSlectedDCValue] = useState(null);
  const [dateRefresh, setDateRefresh] = useState(false);
  const [activeBtnType, setActiveBtnType] = useState("last7Days");

  return (
    <DashboardContext.Provider
      value={{
        selectedSite,
        setSelectedSite,
        selectedBrand,
        setSelectedBrand,
        selectedAcc,
        setSelectedAcc,
        trafficPlusEnabled,
        setTrafficPlusEnabled,
        isDIYAccount,
        setIsDIYAccount,
        selectedDCValue,
        setSlectedDCValue,
        setDateRefresh,
        dateRefresh,
        activeBtnType,
        setActiveBtnType,
      }}
    >
      {children}
    </DashboardContext.Provider>
  );
};

export { DashboardContext, DashboardProvider };
